module.exports = __webpack_public_path__ + "img/emoji.a0846976.jpg";